module.exports = __webpack_public_path__ + "media/images/lb/212-6f83842146e1673e00145de81ed9246f.svg";